"use client";

import messages from "@/i18n/messages/en.json";

import {
  Button,
  DialogDescription,
  DialogTitle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@artha/ui";
import { CircleCheck } from "lucide-react";
import type { TalentNetworkJoinSuccessModalProps } from "../talentNetwork.types";

export function TalentNetworkJoinSuccessModal({
  creatorName,
  isOpen,
  onClose,
}: TalentNetworkJoinSuccessModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="mx-0 w-[calc(100%-2rem)] max-w-sm max-h-[calc(100dvh-2rem)] gap-3 overflow-y-auto rounded-xl border border-black bg-[#FFF8E8] p-5 shadow-[0_4px_0_0_black] !animate-none"
    >
      <ModalHeader className="items-center text-center">
        <CircleCheck aria-hidden="true" className="size-10 text-[#16A34A]" />
        <DialogTitle className="text-xl font-bold leading-6 text-[#101828]">{messages.talentNetworkUi.welcome_to_the_network}</DialogTitle>
      </ModalHeader>
      <ModalBody>
        <DialogDescription className="break-words text-sm leading-5 text-[#667085]">{messages.talentNetworkUi.you_have_joined}{creatorName}{messages.talentNetworkUi.s_talent_network_successfully}</DialogDescription>
      </ModalBody>
      <ModalFooter>
        <Button className="w-full" onClick={onClose}>{messages.talentNetworkUi.explore_jobs}</Button>
      </ModalFooter>
    </Modal>
  );
}
